import { Injectable } from '@angular/core';
import { TurnstileTokenService } from './turnstile-token.service';

export class BaseService {

  constructor(protected turnstileTokenService: TurnstileTokenService) { }

  protected getHeaders: any = (token: string, includeTurnstile: boolean = false) => {
    const headers: any = {};
    
    if (includeTurnstile) {
      const turnstileToken = this.turnstileTokenService.getTurnstileToken();
      if (turnstileToken) {
        headers['x-turnstile-token'] = turnstileToken;
      }
    }

    return headers;
  }
}
